"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var imageSizeMap = {
    icon: 36,
    flag: 24,
    thumbnail: 120,
    spot: 260,
    hero: 460,
};
var getImageSize = function (sizeName) {
    var size = imageSizeMap[sizeName];
    if (!size) {
        throw new Error("getImageSize: Size \"".concat(sizeName, "\" is not supported"));
    }
    return size;
};
exports.default = getImageSize;
